import { render, staticRenderFns } from "./billItem.vue?vue&type=template&id=0f80c738&scoped=true&"
import script from "./billItem.vue?vue&type=script&lang=js&"
export * from "./billItem.vue?vue&type=script&lang=js&"
import style0 from "./billItem.vue?vue&type=style&index=0&id=0f80c738&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f80c738",
  null
  
)

export default component.exports